import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'

Vue.use(Vuex)

const authGlobalEventPlugin = (store) => {
  store.subscribe((mutation, state) => {
    try {
      if (mutation.type === 'auth/SET_LOGIN_STATUS' && state && state.auth && state.auth.isLoggedIn) {
        try {
          const ts = Date.now() + 3000
          sessionStorage.setItem('auth:login-cooldown-until', String(ts))
        } catch (e) {
          // ignore
        }
        const detail = { userInfo: state.auth.userInfo }
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
          window.dispatchEvent(new CustomEvent('auth:login-success', { detail }))
        }
      }
      if (mutation.type === 'auth/CLEAR_USER_INFO') {
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
          window.dispatchEvent(new CustomEvent('auth:logout'))
        }
      }
    } catch (e) {
      // no-op
    }
  })
}

export default new Vuex.Store({
  modules: {
    auth
  },
  plugins: [authGlobalEventPlugin]
})
